export const FACT_FIND_ANSWER_MAP = {
  existingInsurancePolicy: "FactFindCurrentPolicyInPlace",
  renewalDate: "FactFindRenewalDate",
  insuranceProvider: "FactFindCurrentInsurer",
  coverType: "FactFindCurrentCover",
  buildingsAmount: "FactFindBuildingsCoverAmount",
  contentsAmount: "FactFindContentsCoverAmount",
  currentPaymentFrequency: "FactFindPaymentFrequency",
  currentPremium: "FactFindCurrentPremium",
  buildingsCover: "FactFindImportanceBuildingsCover",
  buildingsAccidentalCover: "FactFindImportanceAccidentalBuildings",
  contentsCover: "FactFindImportanceContentsCover",
  contentsAccidentalCover: "FactFindImportanceAccidentalContents",
  coverPersonalBelongings: "FactFindImportancePersonalPossessions",
  coverHomeEmergencies: "FactFindHERequired",
  coverLegalExpenses: "FactFindLERequired",
  policyExcess: "FactFindImportanceExcess",
  newPaymentFrequency: "FactFindPaymentPreference",
  monthlyNetIncome: "FactFindMonthlyNetIncome",
  mortgageAndHome: "FactFindMortgageAndHome",
  lifestyle: "FactFindLifestyle",
  travel: "FactFindTravel",
  borrowingAndDebts: "FactFindBorrowingAndDebts",
  expenses: "FactFindDayToDayExpenses",
  specificNeeds: "FactFindSpecificRequirements",
  totalMonthlyExpenditure: "FactFindTotalMonthlyExpenditure",
  totalSpendableIncome: "FactFindSpendableIncome",

  // LL journey
  landlordCoverEmergencies: "FactFindLandlordsEmergency",
  landlordCoverLegalExpenses: "FactFindLegalExpenses",
  landlordCoverRentProtection: "FactFindRentProtection",
  landlordApplicant1MonthlyNetIncome: "Applicant1FactFindMonthlyNetIncome",
  landlordApplicant1MortgageAndHome: "Applicant1FactFindMortgageAndHome",
  landlordApplicant1Lifestyle: "Applicant1FactFindLifestyle",
  landlordApplicant1Travel: "Applicant1FactFindTravel",
  landlordApplicant1BorrowingAndDebts: "Applicant1FactFindBorrowingAndDebts",
  landlordApplicant1Expenses: "Applicant1FactFindDayToDayExpenses",
  landlordApplicant1TotalMonthlyExpenditure:
    "Applicant1FactFindTotalMonthlyExpenditure",
  landlordApplicant1TotalSpendableIncome: "Applicant1FactFindSpendableIncome",
  landlordApplicant2MonthlyNetIncome: "Applicant2FactFindMonthlyNetIncome",
  landlordApplicant2MortgageAndHome: "Applicant2FactFindMortgageAndHome",
  landlordApplicant2Lifestyle: "Applicant2FactFindLifestyle",
  landlordApplicant2Travel: "Applicant2FactFindTravel",
  landlordApplicant2BorrowingAndDebts: "Applicant2FactFindBorrowingAndDebts",
  landlordApplicant2Expenses: "Applicant2FactFindDayToDayExpenses",
  landlordApplicant2TotalMonthlyExpenditure:
    "Applicant2FactFindTotalMonthlyExpenditure",
  landlordApplicant2TotalSpendableIncome: "Applicant2FactFindSpendableIncome",
};

// HH journey
export const FACT_FIND_FORM = {
  existingInsurancePolicy: false,
  renewalDate: "",
  insuranceProvider: "",
  coverType: "",
  buildingsAmount: "",
  contentsAmount: "",
  currentPaymentFrequency: false,
  currentPremium: "",
  buildingsCover: false,
  buildingsAccidentalCover: false,
  contentsCover: false,
  contentsAccidentalCover: false,
  coverPersonalBelongings: false,
  coverHomeEmergencies: false,
  coverLegalExpenses: false,
  policyExcess: false,
  newPaymentFrequency: false,
  monthlyNetIncome: "",
  mortgageAndHome: "",
  lifestyle: "",
  travel: "",
  borrowingAndDebts: "",
  expenses: "",
  specificNeeds: "",
};

// LL journey
export const LL_FACT_FIND_FORM = {
  existingInsurancePolicy: false,
  renewalDate: "",
  insuranceProvider: "",
  coverType: "",
  buildingsAmount: "",
  contentsAmount: "",
  currentPaymentFrequency: false,
  currentPremium: "",
  buildingsCover: false,
  buildingsAccidentalCover: false,
  contentsCover: false,
  contentsAccidentalCover: false,
  landlordCoverEmergencies: false,
  landlordCoverLegalExpenses: false,
  landlordCoverRentProtection: false,
  policyExcess: false,
  newPaymentFrequency: false,
  landlordApplicant1MonthlyNetIncome: "",
  landlordApplicant1MortgageAndHome: "",
  landlordApplicant1Lifestyle: "",
  landlordApplicant1Travel: "",
  landlordApplicant1BorrowingAndDebts: "",
  landlordApplicant1Expenses: "",
  landlordApplicant2MonthlyNetIncome: "",
  landlordApplicant2MortgageAndHome: "",
  landlordApplicant2Lifestyle: "",
  landlordApplicant2Travel: "",
  landlordApplicant2BorrowingAndDebts: "",
  landlordApplicant2Expenses: "",
  specificNeeds: "",
};
